import React, {Component} from 'react';
import {Table, Button, Badge} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

import './OrgsToValidateList.css';
import {sharedLabelsPath} from '../../../reducers/common/localization';
import {LABEL_PATH_BY_ORG_TYPE} from '../../../reducers/organization/organizations';
import PaginationOrgs from '../../commonComponents/paginationComponent/PaginationOrgs.container';
import {Redirect} from 'react-router-dom';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import RemoveOrgModal from '../removeOrgModal/RemoveOrgModal.container';
import {SUB_ROLES} from '../../../reducers/account/role';

class OrgsToValidateList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validate: false,
            selectedRowData: null,
        };
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        if (this.state.validate) {
            return <Redirect to='/validate-organization' push/>;
        }

        return (
            <div className='org-to-validate-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'orgs.remove_org_success_message')}>
                    <h4 className="page-label">{_.get(this.props.translation, 'orgs.validate_organizations_label')}</h4>
                    <PaginationOrgs/>
                    {this.renderContent()}
                    <RemoveOrgModal data={this.state.selectedOrgData}/>
                </FormWrapper>
            </div>
        )
    }

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="org-to-validate-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="org-to-validate-status-message-container">
                    <h5>{_.get(this.props.translation, 'orgs.no_data_to_validate_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='orgs-to-validate-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'orgs.org_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.org_type_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.anchor_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.location_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.validate_org_progress_label')}</th>
                    <th/>
                    {this.props.subRoles.includes(SUB_ROLES.ROOT) || this.props.subRoles.includes(SUB_ROLES.FA) ? <th/> : null}
                </tr>
                </thead>
                <tbody>
                {this.renderOrgsData()}
                </tbody>
            </Table>
        );
    };

    renderOrgsData = () => {
        return _.map(this.props.data, (orgData, index) => (
            <tr className={'orgs-to-validate-list-row ' + (orgData.active ? '' : 'not-active')} key={index}
                onClick={this.handleTableRowClick(orgData.id)}>
                <td className='org-to-validate-name-td'
                    data-th={_.get(this.props.translation, 'orgs.org_label') + ':'}>{orgData.orgName}</td>
                <td className='org-to-validate-type-td'
                    data-th={_.get(this.props.translation, 'orgs.org_type_label') + ':'}>{_.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[orgData.orgType]])}</td>
                <td className='org-to-validate-anchor-td'
                    data-th={_.get(this.props.translation, 'orgs.anchor_label') + ':'}>
                    <div>{orgData.anchorName + '\n'}</div>
                    <a onClick={this.handleMailtoLinkClick}
                       href={'mailto:' + orgData.anchorEmail}>{orgData.anchorEmail}</a>
                </td>
                <td className='org-to-validate-location-td'
                    data-th={_.get(this.props.translation, 'orgs.location_label') + ':'}>{_.get(this.props.translation, 'countries.' + orgData.location)}</td>
                <td className='org-to-validate-status-td'
                    data-th={_.get(this.props.translation, 'orgs.validate_org_progress_label') + ':'}>
                    {this.getStatusLabel(orgData)}
                </td>
                <td className='validate-organization-btn'>
                    <Button className="btn-sm" color="link">
                        {_.get(this.props.translation, 'orgs.inspect_organization_button')}
                    </Button>
                </td>
                {this.props.subRoles.includes(SUB_ROLES.ROOT) || this.props.subRoles.includes(SUB_ROLES.FA) ? <td className='orgs-list-to-validate-remove-icon-td' onClick={this.handleRemoveButtonClick(orgData)}>
                    <IconContainer
                        key={'trash' + index}
                        icon='trash'
                        className='orgs-list-to-validate-remove-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />
                </td> : null}
            </tr>
        ));
    };

    getStatusLabel = (orgData) => {
        let labels = [];
        if (orgData.generalDataValidated) {
            labels.push(<Badge
                key='general_data_validated'>{_.get(this.props.translation, 'orgs.general_data_validated')}</Badge>);
        }
        if (orgData.financialDataValidated) {
            labels.push(<Badge
                key='financial_data_validated'>{_.get(this.props.translation, 'orgs.financial_data_validated')}</Badge>);
        }
        return labels;
    };

    handleTableRowClick = (id) => () => {
        this.props.onStartValidation(id);
        this.setState({validate: true});
    };

    handleMailtoLinkClick = (e) => {
        e.stopPropagation();
    };

    handleRemoveButtonClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({selectedOrgData: data});
        this.props.onRemoveOrg();
    }
}

const OrgShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    anchorName: PropTypes.string.isRequired,
    anchorEmail: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    orgName: PropTypes.string.isRequired
});

OrgsToValidateList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(OrgShape),
    subRoles: PropTypes.array,
    onMount: PropTypes.func.isRequired,
    onStartValidation: PropTypes.func.isRequired,
    onRemoveOrg: PropTypes.func.isRequired
};

export default OrgsToValidateList;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgsListToValidate/OrgsToValidateList.js